import { HelmetProvider } from "@/lib/react-helmet-async";

type Props = {
	children: React.ReactNode;
};

export const ReactHelmetAsyncProvider = ({ children }: Props) => {
	return <HelmetProvider>{children}</HelmetProvider>;
};
